// TYPES
import { GetAssessmentOverviewTypes } from '../../../apibridge';

type AllOverviewParamTypes = GetAssessmentOverviewTypes[keyof GetAssessmentOverviewTypes];

interface PropsType<T extends AllOverviewParamTypes> {
	type: AllOverviewParamTypes['sortType'];
	params: T;
	setParams: React.Dispatch<React.SetStateAction<T>>;
	disabled?: boolean;
	stageId?: string;
	sortLetter?: string;
	sortText?: string;
	isProgressTable?: boolean;
}

const SortButton = <T extends AllOverviewParamTypes>({
	type,
	params,
	setParams,
	disabled,
	stageId,
	sortLetter,
	sortText,
	isProgressTable
}: PropsType<T>) => {
	// some sort options require different params, others don't
	// going through hoops to account for this
	const sortLetterParam = 'sortLetter' in params;
	const sortTextParam = 'sortText' in params;
	const stageIdMatches = params.sortStageId === undefined || !stageId ? true : params.sortStageId === stageId;
	const sortLetterMatches =
		!sortLetterParam || params.sortLetter === undefined || !sortLetter ? true : params.sortLetter === sortLetter;
	const sortTextMatches =
		!sortTextParam || params.sortText === undefined || !sortText ? true : params.sortText === sortText;

	const direction =
		params.sortType === type && stageIdMatches && sortLetterMatches && sortTextMatches
			? params.sortOrder === 'Ascending'
				? 'up'
				: 'down'
			: undefined;

	const handleClick = () => {
		setParams((prevState) => {
			const sameSortAsBefore =
				type === prevState.sortType &&
				stageId === prevState.sortStageId &&
				'sortLetter' in prevState &&
				sortLetter === prevState.sortLetter &&
				'sortText' in prevState &&
				sortText === prevState.sortText;

			const updatedState = {
				...prevState,
				pageNumber: 1,
				sortType: type,
				sortOrder: sameSortAsBefore ? (prevState.sortOrder === 'Ascending' ? 'Descending' : 'Ascending') : 'Ascending',
				sortStageId: stageId,
				sortLetter,
				sortText
			};

			return updatedState;
		});
	};

	return (
		<button className="sort-btn" onClick={handleClick} disabled={disabled}>
			<img
				src={
					isProgressTable
						? '/svg/sort-btn-icon-transparent.svg'
						: direction === 'down'
						? '/svg/sort-btn-icon-up.svg'
						: direction === 'up'
						? '/svg/sort-btn-icon-down.svg'
						: '/svg/sort-btn-icon-transparent.svg'
				}
				width={20}
				height={20}
				alt="Sort button"
			/>
		</button>
	);
};

export default SortButton;
